<template>
  <v-list dense>
    <v-list-item v-for='d in divisions' :key='d.id' :disabled='d.division==="Construction"||d.division==="Software"' @click="$emit('openAdd', d)">
      <v-list-item-icon>
        <v-icon v-text='d.icon' :color='d.icon_color'></v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ d.division }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'new-estimate-menu',
  computed: {
    divisions () {
      let divisions = this.$store.state.misc.divisions;
      divisions = divisions.filter(function(item){
        return item.division !== "Software" && item.division !== "Construction"
      });
      return divisions;
    }
  }
}
</script>
